import { PreloaderWrapper } from "@/shared/ui/preloader/PreloaderWrapper";
// import { DataLoader } from "./providers/DataProvider";
import RouterProvider from "./providers/RouterProvider";
import { StoreProvider } from "./providers/StoreProvider";

function App() {
    return (
        <StoreProvider>
            <PreloaderWrapper>
                <RouterProvider/>
            </PreloaderWrapper>
        </StoreProvider>
    );
}

export default App;
